import React from "react";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = "",
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`transition rounded-full px-7 py-2 text-xs cursor-pointer  flex justify-center items-center  ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
